export const useApollo = () => {
  const nuxtApp = useNuxtApp()
  return {
    clients: nuxtApp._apolloClients,
  }
}
